export const fonts = {
  text: '"Messina Sans", "Helvetica Neue", "Helvetica", Arial, sans-serif',
  heading: '"Messina Sans", "Helvetica Neue", "Helvetica", Arial, sans-serif',
};
